import { Container } from "atoms/grid-new";
import styled from "styled-components";

const BlogContainer = styled(Container)`
  font-family: Open Sans;
`;

export default BlogContainer;
